/**
 * Latvian is the source dictionary: it is the school's language and the default (`db/types.ts`).
 * Every other locale is typed against `Dict`, so a missing key is a compile error.
 *
 * Dates and weekday names are NOT in here — those come from `Intl` via `format.ts`.
 * Substitution text from EduPage is never translated (CLAUDE.md); it is shown verbatim and
 * labelled with `lesson.fromSchool`.
 */
export const lv = {
  "app.title": "Stundio",
  "general.continue": "Turpināt",

  "nav.home": "Sākums",
  "nav.week": "Nedēļa",
  "nav.changes": "Izmaiņas",
  "nav.subjects": "Priekšmeti",
  "nav.transit": "Transports",
  "nav.settings": "Iestatījumi",
  "nav.group.schedule": "Grafiks",
  "nav.group.personal": "Personīgi",

  "onboarding.title": "Izvēlies savu klasi",
  "onboarding.subtitle": "Stundu saraksts un izmaiņas — arī bez interneta.",

  "onboarding.persona.title": "Izvēlies savu pusi",
  "onboarding.persona.subtitle": "Pielāgo sarakstu savām vajadzībām",
  "onboarding.persona.student.title": "Skolēns",
  "onboarding.persona.student.desc": "Gribu redzēt savas klases stundas un izmaiņas",
  "onboarding.persona.teacher.title": "Skolotājs",
  "onboarding.persona.teacher.desc": "Gribu redzēt savas stundas, kabinetus un aizvietošanas",

  "onboarding.teacher.title": "Izvēlies skolotāju",
  "onboarding.teacher.subtitle": "Meklē pēc vārda vai uzvārda",

  "teacher.search": "Meklēt skolotāju…",
  "teacher.none": "Nav atrasts neviens skolotājs",
  "teacher.formClass": "Klases audzinātājs",
  "teacher.cover": "Aizvietošana",
  "teacher.coverFor": "Aizvieto: {name}",
  "teacher.view.own": "Manas stundas",
  "teacher.view.formClass": "Mana klase",

  "onboarding.language.title": "Izvēlies valodu",
  "onboarding.language.continue": "Turpināt",

  "onboarding.intro.skip": "Izlaist",
  "onboarding.intro.next": "Tālāk",
  "onboarding.intro.start": "Sākt",
  "onboarding.intro.progress": "Iepazīšanās solis",
  "onboarding.intro.step1.title": "Stundu saraksts vienā vietā",
  "onboarding.intro.step1.body": "Diena un nedēļa pārskatāmi — tāpat kā EduPage, bet ātrāk.",
  "onboarding.intro.step2.title": "Izmaiņas uzreiz redzamas",
  "onboarding.intro.step2.body":
    "Atceltas, pārceltas un aizvietotas stundas iezīmētas — nekas nepaliek nepamanīts.",
  "onboarding.intro.step3.title": "Strādā arī bez interneta",
  "onboarding.intro.step3.body":
    "Saraksts saglabājas ierīcē, tāpēc tas ir pieejams pat bez pieslēguma.",
  "onboarding.intro.step4.title": "Paziņojumi par to, kas svarīgi",
  "onboarding.intro.step4.body":
    "Atgādinājums pirms stundas un ziņa, ja mainās aizvietojumi — nekas cits.",

  "class.search": "Meklēt klasi…",
  "class.none": "Nav atrasta neviena klase",
  "class.favorites": "Izlase",
  "class.all": "Visas klases",
  "class.loading": "Ielādē klašu sarakstu…",
  "class.favorite.add": "Pievienot izlasei",
  "class.favorite.remove": "Noņemt no izlases",

  "subgroup.title": "Kurā {class} pusgrupā tu esi?",
  "subgroup.subtitle":
    "Klase ir sadalīta pusgrupās — izvēlies savējo, lai redzētu tikai savas stundas.",
  "subgroup.option": "{label}. pusgrupa",
  "subgroup.skip": "Izlaist — rādīt abas pusgrupas",

  "day.today": "Šodien",
  "day.tomorrow": "Rīt",
  "day.yesterday": "Vakar",
  "day.jumpToday": "Uz šodienu",
  "day.previousDay": "Iepriekšējā diena",
  "day.nextDay": "Nākamā diena",
  "day.openCalendar": "Izvēlēties datumu",
  "day.previousMonth": "Iepriekšējais mēnesis",
  "day.nextMonth": "Nākamais mēnesis",
  "day.pageHint": "Velc pa kreisi vai pa labi, vai izmanto bultiņu taustiņus, lai mainītu dienu",
  "day.empty": "Stundu nav",
  "day.emptyHint": "Brīvdiena vai svētku diena?",
  "day.noClass": "Vispirms izvēlies klasi",
  "day.changeClass": "Mainīt klasi",
  "day.noData": "Nav saglabātu datu",
  "day.noDataHint": "Pievienojies internetam, lai lejupielādētu sarakstu.",
  "week.longBreak": "Garais starpbrīdis · {min} min",
  "week.noSchedule": "Šai nedēļai vēl nav saraksta",
  "week.noScheduleHint":
    "Parasti tas parādās tuvāk datumam. Velc uz leju, lai pārbaudītu atjauninājumus.",
  "day.stale": "Šai nedēļai saraksts vēl nav publicēts — rādām iepriekšējo.",
  "day.offline": "Nav interneta pieslēguma — rādām saglabāto sarakstu.",
  "day.buildingOther": "Cita ēka: {building}",
  "day.buildingMixed": "Vairākas ēkas: {buildings}",
  "home.schedule": "Dienas saraksts",
  "home.notifyBlocked": "Paziņojumi ir izslēgti — atgādinājumi un izmaiņu brīdinājumi nenāks.",
  "home.notifyBlockedWeb":
    "Paziņojumi ir bloķēti pārlūkprogrammā — ieslēdz tos vietnes iestatījumos, lai saņemtu brīdinājumus.",
  "day.notes": "Paziņojumi",
  "day.allNotes": "Visi skolas paziņojumi ({count})",
  "day.onlyMyGroup": "Tikai manai grupai",
  "day.free": "Brīvstunda",
  "day.finished": "Stundas beigušās",
  "day.now": "Tagad",
  "day.glance.left": "Atlikušas {duration}",
  "day.glance.in": "Pēc {duration}",
  "day.glance.following": "Tālāk",
  "day.glance.walk": "Jādodas uz {building}",
  "day.glance.walkFrom": "Pāreja no {from} uz {building}",
  "day.summary.lessons": "Stundas: {count}",
  "day.summary.free": "Brīvs: {duration}",
  "day.summary.lessonsTooltip": "Kopējais stundu skaits šodien",
  "day.summary.freeTooltip": "Kopējais brīvais laiks starp stundām",
  "day.tomorrow.eyebrow": "Nākamā mācību diena · {weekday}",
  "day.tomorrow.starts": "Sākas {time}",
  "day.tomorrow.changes": "Izmaiņas: {count}",
  "day.tomorrow.open": "Atvērt {weekday}: sākas plkst. {time}",
  "day.glance.open": "Atvērt {title}, {countdown}",
  "day.feedbackPrompt.title": "Ir ideja?",
  "day.feedbackPrompt.body": "Pastāsti, ko Stundio vajadzētu pievienot vai labot.",
  "day.feedbackPrompt.action": "Ieteikt",
  "day.feedbackPrompt.dismiss": "Aizvērt",
  "day.androidBanner.title": "Stundio Android lietotne",
  "day.androidBanner.body":
    "Lejupielādē lietotni sākuma ekrāna logrīkiem, fona sinhronizācijai un bezsaistes stundu sarakstam.",
  "day.androidBanner.action": "Lejupielādēt APK",
  "day.androidBanner.dismiss": "Aizvērt",
  "day.updatePrompt.title": "Pieejams jauninājums",
  "day.updatePrompt.body": "Pieejama jaunāka Stundio versija ({version}).",
  "day.updatePrompt.action": "Atjaunināt",
  "day.updatePrompt.dismiss": "Vēlāk",
  "day.updatePrompt.handoff":
    "Lejupielāde pabeigta. Apstiprini instalēšanu Android logā vai nospied “Atjaunināt”, lai mēģinātu vēlreiz.",
  "day.changesBadge": "{n} izmaiņas",

  "changes.title": "Izmaiņas",
  "changes.filter.myClass": "Mana grupa",
  "changes.filter.myChanges": "Manas izmaiņas",
  "changes.filter.all": "Visa skola",
  "changes.absentTeachers": "Šodien prombūtnē",
  "changes.emptyForClass": "Izmaiņu nav",
  "changes.emptyForClassHint": "Tavai grupai šai dienai stundas notiek pēc pamatsaraksta",
  "changes.emptyAll": "Nav reģistrētu izmaiņu",
  "changes.emptyAllHint": "Skola nav publicējusi izmaiņas šai dienai",
  "changes.otherGroupsHaveChanges": "Šodien ir {n} izmaiņas citām grupām",
  "changes.viewOtherGroups": "Skatīt visas izmaiņas",
  "changes.searchPlaceholder": "Meklēt grupu, priekšmetu vai skolotāju…",
  "changes.searchNoResults": "Nekas netika atrasts",
  "changes.count": "{n} izmaiņas",
  "changes.badge": "{n} izmaiņas",
  "changes.notesFromSchool": "Skolas paziņojumi",
  "changes.rvtWebsite": "Skatīt RVT lapā",

  "week.previousWeek": "Iepriekšējā nedēļa",
  "week.nextWeek": "Nākamā nedēļa",
  "week.buildingDays": "{building}: {days}",
  "week.overview.title": "Pārskats",
  "week.overview.lessons": "{n} stundas",
  "week.overview.lessonsUp": "+{n} salīdzinot ar iepriekšējo nedēļu",
  "week.overview.lessonsDown": "{n} salīdzinot ar iepriekšējo nedēļu",
  "week.overview.lessonsSame": "Tik pat, cik iepriekšējā nedēļā",
  "week.overview.changes": "{n} izmaiņas",
  "week.overview.changesNone": "Nav izmaiņu",
  "week.overview.busiestLabel": "Noslogotākā diena",
  "week.overview.lightestLabel": "Vieglākā diena",

  "share.week": "Dalīties ar nedēļu",
  "share.working": "Sagatavo attēlu…",
  "share.error": "Neizdevās sagatavot attēlu",
  "share.title": "{name} stundu saraksts",
  "share.message":
    "{name} stundu saraksts {period} \nVēlies ērtāk lietot EduPage? Ieskaties: https://bit.ly/stundio",
  "share.image.classTeacher": "Klases audzinātājs",
  "share.image.appLabel": "Labāka EduPage pieredze tālrunī",
  "share.language.title": "Kādā valodā kopīgot?",
  "share.language.sync": "Sinhronizēt kopīgoto attēlu ar lietotnes valodu",
  "share.language.continue": "Turpināt",

  "lesson.teacher": "Skolotājs",
  "lesson.room": "Kabinets",
  "lesson.period": "Stunda",
  "lesson.group": "Grupa",
  "lesson.building": "Ēka",
  "lesson.was": "Bija",
  "lesson.fromSchool": "No skolas",
  "lesson.note": "Paziņojums",
  "lesson.close": "Aizvērt",

  "status.cancelled": "Atcelta",
  "status.moved": "Pārcelta",
  "status.substituted": "Aizvietota",
  "status.room_change": "Cits kabinets",
  "status.added": "Papildu stunda",

  "sync.syncing": "Atjaunina…",
  "sync.offline": "Bezsaistē",
  "sync.error": "Neizdevās atjaunināt",
  "sync.never": "Vēl nav atjaunināts",
  "sync.updated": "Atjaunināts {time}",
  "sync.refresh": "Atjaunināt",
  "sync.pull": "Velc, lai atjauninātu",
  "sync.release": "Atlaid, lai atjauninātu",
  "sync.toast": "Atjaunināts",

  "time.inMinutes": "pēc {n} min",
  "time.minutesLeft": "atlikušas {n} min",
  "time.startsNow": "sākas tūlīt",

  "subjects.title": "Priekšmeti",
  "transit.title": "Transports",
  "transit.plan.title": "Mans maršruts",
  "transit.plan.description":
    "Ievadi sākuma un galamērķa adresi. Maršrutu vari atvērt Google Maps.",
  "transit.plan.home": "Sākuma vieta",
  "transit.plan.homePlaceholder": "Mājas adrese",
  "transit.plan.useLocation": "Izmantot manu atrašanās vietu",
  "transit.plan.savedHome": "Sākumpunkts no iestatījumiem: {address}",
  "transit.plan.homeMissing":
    "Pievieno mājas adresi iestatījumos vai izmanto pašreizējo atrašanās vietu.",
  "transit.plan.destination": "Galamērķis",
  "transit.plan.destinationPlaceholder": "Adrese vai vietas nosaukums",
  "transit.plan.transitDuration": "Transports un pārsēšanās (minūtēs)",
  "transit.plan.walkDuration": "Iešana līdz pieturai (minūtēs)",
  "transit.plan.nextLesson": "Nākamā stunda: {subject}, plkst. {time}",
  "transit.plan.class": "stunda",
  "transit.plan.leaveAt": "Iziet ap {time}",
  "transit.plan.leaveHint": "Ietver norādīto iešanas un transporta laiku.",
  "transit.plan.noLesson": "Šodien vairs nav gaidāmu stundu izvēlētajai klasei.",
  "transit.plan.findRoute": "Meklēt sabiedriskā transporta maršrutu",
  "transit.plan.destinationNeeded": "Ievadi galamērķi, lai meklētu maršrutu.",
  "transit.plan.mapsNote": "Google Maps parādīs pieejamos maršrutus un atiešanas laikus.",
  "transit.plan.mapsKeyNeeded":
    "Iekļautajai Google Maps kartei nepieciešama lietotnes konfigurācija.",
  "transit.plan.mapTitle": "Sabiedriskā transporta maršruts Google Maps",
  "transit.plan.goToSchool": "Uz skolu",
  "transit.plan.goHome": "Uz mājām",
  "transit.plan.schoolDay": "Pirmā stunda {start} · {building} · pēdējā stunda līdz {end}",
  "transit.plan.main": "Galvenajā ēkā",
  "transit.plan.tic": "Tehnoloģiju un inovāciju centrā",
  "transit.plan.startsAtSeven": "Maršruti uz skolu būs redzami no plkst. 7.00.",
  "transit.plan.fromTo": "Maršruts",
  "transit.plan.currentLocation": "Tava atrašanās vieta",
  "transit.plan.homeAddress": "Mājas ({address})",
  "transit.plan.homeward": "mājām",
  "transit.plan.noHome": "mājas adrese nav iestatīta",
  "transit.plan.refreshLocation": "Atjaunot GPS",
  "transit.plan.refreshRoutes": "Atjaunot maršrutus",
  "transit.plan.lessonsAtTic": "Stundas notiek Tehnoloģiju un inovāciju centrā.",
  "transit.plan.alreadyAtSchool": "Tu jau esi pie skolas.",
  "transit.plan.loadingRoutes": "Meklējam sabiedriskā transporta maršrutus…",
  "transit.plan.routesKeyNeeded":
    "Lai parādītu maršrutus, lietotnei jāpievieno Google Routes API atslēga.",
  "transit.plan.routesUnavailable":
    "Maršrutus pašlaik neizdevās ielādēt. Mēģini vēlreiz pēc brīža.",
  "transit.plan.noRoutes": "Šim maršrutam nav atrasti sabiedriskā transporta savienojumi.",
  "transit.plan.option": "Variants {number}",
  "transit.plan.leaveAround": "Iziet no mājām ap {time}",
  "transit.plan.walk": "Iet kājām",
  "transit.plan.locationUnavailable": "Šajā ierīcē atrašanās vieta nav pieejama.",
  "transit.plan.locationLoading": "Nosaka atrašanās vietu…",
  "transit.plan.locationReady": "Atrašanās vieta izmantota šim maršrutam.",
  "transit.plan.locationDenied": "Neizdevās noteikt atrašanās vietu. Pārbaudi pārlūka atļaujas.",
  "transit.live.title": "Rīgas satiksme reāllaikā",
  "transit.live.description":
    "Apskati transportlīdzekļu atrašanās vietas kartē un reāllaika pienākšanas laikus pieturās.",
  "transit.live.show": "Rādīt tiešsaistes karti",
  "transit.live.source": "Tiešraides karte no Rīgas satiksmes",
  "transit.live.openFull": "Atvērt pilnā ekrānā",
  "transit.live.frameTitle": "Rīgas satiksmes reāllaika transporta karte",
  "transit.destinations.title": "Saglabātās adreses",
  "transit.destinations.description": "Saglabātā adrese ir maršruta sākumpunkts līdz RVT.",
  "transit.destinations.currentLocation": "No pašreizējās atrašanās vietas",
  "transit.destinations.rvtAddress": "Galamērķis: RVT · {address}",
  "transit.destinations.openGoogleMaps": "Atvērt Google Maps",
  "transit.destinations.nameLabel": "Vietas nosaukums",
  "transit.destinations.namePlaceholder": "Skola, darbs, draugi…",
  "transit.destinations.addressLabel": "Adrese",
  "transit.destinations.addressPlaceholder": "Iela, ēka, pilsēta",
  "transit.destinations.add": "Pievienot adresi",
  "transit.destinations.remove": "Noņemt {label}",
  "transit.destinations.locationUnavailable": "Šajā ierīcē atrašanās vieta nav pieejama.",
  "transit.destinations.gettingLocation": "Nosaka atrašanās vietu…",
  "transit.destinations.locationDenied": "Atļauj piekļuvi atrašanās vietai, lai plānotu maršrutu no tās.",
  "transit.destinations.plannerTitle": "Rīgas satiksmes maršruta plānotājs",
  "transit.destinations.plannerDescription": "Atvērts maršruta plānotājs adresei: {destination}.",
  "transit.destinations.backToMap": "Atpakaļ uz karti",
  "transit.live.locationNote":
    "Lai karte rādītu tavu atrašanās vietu, izmanto atrašanās vietas pogu kartē un atļauj piekļuvi, ja pārlūks to pieprasa.",
  "subjects.perWeek": "{n}× nedēļā",
  "subjects.teachers": "Skolotāji",
  "subjects.empty": "Nav priekšmetu",
  "subjects.emptyHint": "Priekšmeti parādīsies, kad būs lejupielādēts saraksts.",
  "subjects.note.placeholder": "Piezīme šim priekšmetam…",
  "subjects.note.save": "Saglabāt",
  "subjects.note.badge": "Ir piezīme",

  "settings.title": "Iestatījumi",
  "settings.commute": "Ceļš uz skolu",
  "settings.commute.home": "Mājas adrese",
  "settings.commute.homePlaceholder": "Ievadi adresi vai vietas nosaukumu",
  "settings.commute.homeHint":
    "Adrese tiek saglabāta tikai šajā ierīcē un izmantota maršruta plānošanai.",
  "settings.persona.student": "Skolēns",
  "settings.persona.teacher": "Skolotājs",
  "settings.identity.sheetTitle": "Izvēlies lomu",
  "settings.identity.confirm": "Apstiprināt",
  "settings.class": "Mana grupa",
  "settings.change": "Mainīt",
  "settings.building": "Ēka",
  "settings.buildingAuto": "Automātiski",
  "settings.subgroup": "Pusgrupa",
  "settings.subgroupAll": "Abas",
  "settings.customization": "Izskats",
  "settings.theme": "Noformējums",
  "settings.language": "Valoda",
  "settings.share": "Kopīgošana",
  "settings.shareLanguage": "Kopīgotā attēla valoda",
  "settings.mergeLessons": "Apvienot vienādas stundas",
  "settings.mergeLessonsHint":
    "Pēc kārtas atkārtotu priekšmetu nedēļas skatā rāda kā vienu garāku bloku.",
  "settings.movedOnTarget": "Pārceltās stundas rādīt jaunajā dienā",
  "settings.movedOnTargetHint":
    "Uz citu dienu pārceltā stunda parādās tajā dienā, nevis tajā, no kuras tā pārcelta.",
  "view.options": "Skata opcijas",
  "settings.showTime": "Rādīt laiku",
  "settings.showTimeHint": "Rāda katras stundas sākuma un beigu laiku pie tās numura.",
  "settings.showSubjectsTab": "Cilne “Priekšmeti”",
  "settings.showSubjectsTabHint": "Rāda priekšmetu cilni apakšējā izvēlnē, blakus iestatījumiem.",
  "settings.notifications": "Paziņojumi",
  "settings.notifyLessonReminder": "Atgādinājums pirms stundas",
  "settings.notifyLessonReminderHint": "Paziņo pirms nākamās stundas sākuma.",
  "settings.notifyLessonReminderOff": "Izslēgts",
  "settings.notifySubstitutionChanges": "Izmaiņas sarakstā",
  "settings.notifySubstitutionChangesHint": "Paziņo, ja mainās šodienas vai rītdienas stundas.",
  "settings.notifyNewTimetable": "Jauns stundu saraksts",
  "settings.notifyNewTimetableHint": "Paziņo, kad skola izliek jaunās nedēļas stundu sarakstu.",
  "settings.notifyAppUpdates": "Jauninājumi",
  "settings.notifyAppUpdatesHint": "Paziņo, kad iznāk jauna lietotnes versija.",
  "settings.notifyExactAlarmDenied":
    "Sistēma neļauj precīzus modinātājus — atgādinājumi var kavēties. Ieslēdz «Modinātāji un atgādinājumi».",
  "settings.notifyPermissionDenied": "Paziņojumi ir bloķēti sistēmas iestatījumos.",
  "settings.notifyOpenSettings": "Atvērt iestatījumus",
  "settings.notificationsWebNotice":
    "Bezsaistes atgādinājumi un paziņojumi ir pieejami Android lietotnē. Tīmekļa lietotnē izmaiņas atjaunojas, to atverot.",
  "settings.notificationsIosPwaRequired":
    "Lai saņemtu paziņojumus iPhone tālrunī, vispirms pievienojiet Stundio sākuma ekrānam.",
  "settings.notificationsLessonRemindersNativeNotice":
    "Stundu atgādinājumi pirms katras stundas ir pieejami Android lietotnē. Paziņojumi par izmaiņām sarakstā darbojas caur tīmekļa paziņojumiem.",
  "notification.lessonReminder.title": "{subject} pēc {minutes} min",
  "notification.changed.title": "Izmaiņas stundu sarakstā",
  "notification.changed.body": "Šodienas sarakstā ir izmaiņas.",
  "notification.cover.title": "Jauna aizvietošana",
  "notification.cover.body": "Tev piešķirta aizvietošanas stunda",
  "notification.newTimetable.title": "Jauns stundu saraksts",
  "notification.newTimetable.body": "Izlikts jauns stundu saraksts no {date}.",
  "notification.update.title": "Pieejams jauninājums",
  "notification.update.body": "Stundio {version} ir pieejama lejupielādei.",
  "widget.now": "Tagad",
  "widget.next": "Nākamā",
  "widget.done": "Šodien stundu vairs nav",
  "widget.noClass": "Izvēlies klasi",
  "widget.noData": "Atver Stundio, lai atjaunotu",
  "widget.minutesLeft": "vēl {minutes} min",
  "widget.minutesUntil": "pēc {minutes} min",
  "settings.data": "Dati",
  "settings.analytics": "Anonīma lietošanas statistika",
  "settings.analyticsHint":
    "Palīdz saprast, kuras funkcijas tiek izmantotas. Bez sīkfailiem un personas datiem.",
  "settings.about": "Par lietotni",
  "settings.aboutText":
    "Neoficiāla lietotne. Dati nāk no publiskā pikcrvt.edupage.org saraksta un pieder skolai.",
  "settings.currentVersion": "Pašreizējā versija: {version}",
  "settings.checkForUpdatesAction": "Pārbaudīt",
  "settings.checkingForUpdates": "Pārbauda…",
  "settings.upToDate": "Ir jaunākā versija",
  "settings.updateAvailable": "Pieejama jaunāka versija ({version})",
  "settings.updateAction": "Lejupielādēt",
  "settings.updateDownloading": "Lejupielādē… {percent}%",
  "settings.updateError": "Neizdevās atjaunināt: {message}",
  "settings.updateFailed": "Neizdevās atjaunināt",
  "whatsNew.title": "Kas jauns",
  "whatsNew.eyebrow": "Versija {version}",
  "whatsNew.done": "Sapratu",
  "whatsNew.history": "Iepriekšējās versijas",
  "whatsNew.empty": "Vēl nav izmaiņu saraksta.",
  "settings.whatsNew": "Kas jauns",
  "settings.whatsNewHint": "Izmaiņas šajā un iepriekšējās versijās",
  "settings.dangerZone": "Bīstamā zona",
  "settings.resetData": "Dzēst visus datus",
  "settings.resetDataHint": "Dzēš piezīmes un atiestata visus iestatījumus.",
  "settings.resetDataConfirmTitle": "Dzēst visus datus?",
  "settings.resetDataConfirmBody":
    "Tiks dzēstas visas piezīmes un visi iestatījumi tiks atiestatīti uz noklusējuma vērtībām. Lietotne atgriezīsies sākotnējā stāvoklī.",
  "settings.resetDataConfirmButton": "Dzēst visus datus",
  "settings.resetDataCancelButton": "Atcelt",
  "feedback.sheet.title": "Ieteikt funkciju",
  "feedback.sheet.messageLabel": "Tava ideja vai ieteikums",
  "feedback.sheet.messagePlaceholder": "Ko Stundio vajadzētu pievienot vai uzlabot?",
  "feedback.sheet.emailLabel": "Tavs e-pasts (neobligāti)",
  "feedback.sheet.emailPlaceholder": "Ja vēlies saņemt atbildi",
  "feedback.sheet.submit": "Nosūtīt ieteikumu",
  "feedback.sheet.submitting": "Nosūta…",
  "feedback.sheet.successTitle": "Paldies par ieteikumu!",
  "feedback.sheet.successBody": "Tava ideja ir nosūtīta. Paldies par ieguldījumu!",
  "feedback.sheet.bugTitle": "Ziņot par kļūdu",
  "feedback.sheet.bugMessageLabel": "Kas notika?",
  "feedback.sheet.bugMessagePlaceholder": "Apraksti, kas nogāja greizi un ko tu gaidīji…",
  "feedback.sheet.bugSubmit": "Nosūtīt ziņojumu",
  "feedback.sheet.bugSubmitting": "Nosūta…",
  "feedback.sheet.bugSuccessTitle": "Ziņojums nosūtīts!",
  "feedback.sheet.bugSuccessBody": "Paldies par ziņojumu! Mēs to izskatīsim.",
  "feedback.sheet.close": "Aizvērt",
  "feedback.sheet.error": "Neizdevās nosūtīt. Pārbaudi interneta savienojumu.",
  "feedback.sheet.attachScreenshot": "Pievienot ekrānuzņēmumu",
  "feedback.sheet.removeScreenshot": "Noņemt ekrānuzņēmumu",
  "feedback.sheet.screenshotTooLarge": "Attēls ir pārāk liels (maks. 5 MB)",
  "settings.madeBy": "Made with ❤︎ by Dmytro Polizhai",

  "theme.system": "Kā sistēmā",
  "theme.light": "Gaišs",
  "theme.dark": "Tumšs",

  "customization.title": "Izskats",
  "customization.theme": "Noformējums",
  "customization.accent": "Akcentkrāsa",
  "customization.accent.hint":
    "Krāsa izceltiem elementiem — šodienas datumam, izvēlētajām opcijām.",
  "customization.accent.reset": "Noklusējuma",
  "customization.lessonStyle": "Stundu kartītes",
  "customization.lessonStyle.hint": "Kā priekšmeta krāsa parādās dienas sarakstā.",
  "customization.lessonStyle.outline": "Kontūra",
  "customization.lessonStyle.filled": "Aizpildīta",
  "customization.radius": "Stūru noapaļojums",
  "customization.radius.compact": "Kompakts",
  "customization.radius.balanced": "Vidējs",
  "customization.radius.standard": "Standarta",
  "customization.radius.rounder": "Vairāk noapaļots",
  "customization.elevation": "Kartīšu dziļums",
  "customization.elevation.soft": "Viegls",
  "customization.elevation.bold": "Izteikts",
  "customization.reduceMotion": "Mazāk animāciju",
  "customization.reduceMotion.hint": "Izslēdz lietotnes pārejas un animācijas.",
  "customization.subjectColors": "Priekšmetu krāsas",
  "customization.subjectColors.enabled": "Priekšmetu krāsu kodēšana",
  "customization.subjectColors.enabled.hint":
    "Izslēdzot, katrs priekšmets stundu sarakstā un nedēļas skatā rāda vienu neitrālu krāsu.",
  "customization.subjectColors.hint":
    'Pieskaries krāsai, lai to mainītu; pieskaries "Auto", lai atgrieztos pie noklusējuma.',
  "customization.subjectColors.reset": "Auto",
  "customization.subjectColors.custom": "Pielāgota krāsa",
  "customization.subjectColors.lightness": "Gaišums",
  "customization.subjectColors.empty": "Izvēlies klasi, lai pielāgotu priekšmetu krāsas.",
  "customization.subjectColors.hint.teacher":
    'Tie ir priekšmeti, kurus tu pasniedz. Pieskaries krāsai, lai to mainītu; pieskaries "Auto", lai atgrieztos pie noklusējuma.',
  "customization.subjectColors.empty.teacher":
    "Izvēlies sevi kā skolotāju, lai pielāgotu savu priekšmetu krāsas.",
  "customization.preview.subject": "Piemēra priekšmets",
  "customization.reset": "Atjaunot noklusējumu",

  "iphoneInstall.title": "Pievieno Stundio sākuma ekrānam",
  "iphoneInstall.subtitle":
    "Lieto Stundio kā pilnvērtīgu lietotni savā iPhone — bez pārlūka joslām un ar tūlītēju bezsaistes piekļuvi.",
  "iphoneInstall.step1": "Nospied pogu zemāk «Pievienot sākuma ekrānam» vai pārlūka pogu Kopīgot",
  "iphoneInstall.step2": "Izvēlnē izvēlies «Pievienot sākuma ekrānam»",
  "iphoneInstall.action": "Pievienot sākuma ekrānam",
  "teacherAnnouncement.title": "Stundio skolotājiem",
  "teacherAnnouncement.headline": "Tagad pieejams arī skolotājiem",
  "teacherAnnouncement.subtitle":
    "Skolotāji tagad var izmantot Stundio, lai apskatītu savas stundas, kabinetus un aizvietošanas.",
  "teacherAnnouncement.step1.title": "Dodies uz iestatījumiem",
  "teacherAnnouncement.step1.desc": "Atver iestatījumu sadaļu",
  "teacherAnnouncement.step2.title": "Maini profilu",
  "teacherAnnouncement.step2.desc": "Izvēlies skolotāja profilu",
  "teacherAnnouncement.step3.title": "Izvēlies savu vārdu",
  "teacherAnnouncement.step3.desc": "Atrodi sevi sarakstā un saņem savu stundu sarakstu",
  "teacherAnnouncement.tryIt": "Izmēģināt",
  "teacherAnnouncement.done": "Sapratu",
  "settings.teacherShare": "Paziņojums skolotājiem",
  "settings.teacherShareHint": "Parādīt paziņojumu par funkcijām skolotājiem",
  "iphoneInstall.dismiss": "Turpināt pārlūkā",
  "settings.iphoneInstall": "Pievienot sākuma ekrānam",
  "settings.iphoneInstallHint": "Instalēt Stundio kā lietotni savā iPhone",

  "settings.group.schedule": "Saraksts",
  "settings.group.appearance": "Izskats un valoda",
  "settings.identityHint": "Kura saraksts rādās sākumā, nedēļā un logrīkā.",
  "settings.subgroupHint": "Paslēpj otras pusgrupas stundas no dienas un nedēļas.",
  "settings.buildingHint": "Rādīt tikai vienas ēkas sarakstu vai abu kopā.",
  "settings.themeHint": "Gaišs, tumšs vai kā tālruņa sistēmā.",
  "settings.languageHint": "Lietotnes valoda. Priekšmeti un izmaiņas paliek latviski, kā EduPage.",
  "settings.customizationHint": "Priekšmetu krāsas, akcents, kartīšu stils un noapaļojums.",
  "settings.shareLanguageHint": "Kādā valodā parakstīts nedēļas attēls un ziņa, ar ko dalies.",
  "settings.shareLangFollowApp": "Kā lietotnē",
  "settings.sync": "Sinhronizācija",
  "settings.syncHint":
    "Saraksts glabājas tālrunī un strādā bez interneta. Pieskaries, lai atjauninātu.",
  "settings.updates": "Atjauninājumi",
  "settings.updatesHint": "Pārbauda un instalē jaunu versiju tieši no lietotnes.",
  "settings.version": "Versija",
  "settings.versionHint": "Lietotnes versija šajā ierīcē.",
  "settings.reportIssueRow": "Ziņot par kļūdu",
  "settings.reportIssueHint": "Apraksti problēmu — autors to saņems kopā ar lietotnes versiju.",
  "settings.suggestFeatureRow": "Ieteikt ideju",
  "settings.suggestFeatureHint": "Ko pievienot vai mainīt lietotnē.",
  "settings.notifyPermissionDeniedTitle": "Paziņojumi bloķēti",
  "settings.notifyExactAlarmTitle": "Atgādinājumi var kavēties",
  "settings.notificationsWebTitle": "Paziņojumi Android lietotnē",
  "settings.minutes": "{minutes} min",
  "settings.reminderOption": "{minutes} min pirms stundas",

  "error.title": "Kaut kas nogāja greizi",
  "error.hint": "Neizdevās ielādēt šo skatu.",
  "error.retry": "Mēģināt vēlreiz",
} as const;

export type Dict = Record<keyof typeof lv, string>;
export type MessageKey = keyof typeof lv;
